import axios, { AxiosResponse } from 'axios';
import { ISeat, ISeatDetails, ISeatState } from 'types/shared';
import { apiURL } from 'utils/constants';

const seatsURL = apiURL + 'Seats';
const seatStatesURL = apiURL + 'SeatStates';

const SeatsApiWrapper = {
	getSeats: (): Promise<ISeat[]> => {
		const seats = axios.get(seatsURL).then((result) => result.data as ISeat[]);
		return seats;
	},

	getSeatState: (): Promise<ISeatState[]> => {
		const seatStates = axios.get(seatStatesURL).then((result) => result.data as ISeatState[]);
		return seatStates;
	},


	putSeat: (seat: ISeat): Promise<AxiosResponse> => {
		return axios.put(seatsURL, seat);
	},

	getEmployeeSeats: (employeeId: number): Promise<ISeat[]> => {
		const seats = axios
			.get(`${apiURL?.replace('/api/v1/', '')}/Employees/${employeeId}/Seats`)
			.then((result) => result.data as ISeat[]);
		return seats;
	},

	getEmployeeSeatDetails: (employeeId: number): Promise<ISeatDetails[]> => {
		const seats = axios
			.get(`${apiURL?.replace('/api/v1/', '')}/Employees/${employeeId}/SeatDetails`)
			.then((result) => result.data as ISeatDetails[]);
		return seats;
	},

};

export default SeatsApiWrapper;
